import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'ODS': {
      'TITULO': 'Perfil de empresa',
      'TOOLBAR': {
        'NUEVA': 'Cree el perfil para una empresa',
        'EDITAR': 'Puede modificar los datos del perfil de esta empresa',
        'CAMBIOS': '(los cambios se guardan automáticamente)',
        'DESCARGAR': 'Descargar información de la empresa'
      },
      'FORMULARIOS': {
        '0': 'Información de la empresa',
        '1': 'Responsable del proyecto',
        '2': 'Director de recursos humanos',
        '3': 'Responsable de TI',
      },
      'BOTONES': {
        'BACK': 'Anterior',
        'NEXT': 'Siguiente',
        'ACEPTAR': 'Aceptar'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'Ya existe una empresa registrada con el nombre especificado, intente crear la empresa nuevamente con otro nombre',
        'ERROR_GUARDADO': 'Ocurrió un error al crear la empresa, vuelva a intentarlo más tarde',
        'GUARDANDO': 'Guardando cambios',
        'GENERANDO_PDF': 'Generando archivo PDF, espere un momento'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Broker',
        'country_application': 'País broker',
        'nombreEmpresa': 'Empresa',
        'shortName': 'Nombre corto de empresa',
        'nombrePublicacion': 'Nombre de la empresa para la publicación',
        'account_id': 'Account ID',
        'idSalesForce': 'ID de cliente',
        'codigoProyecto': 'Código de proyecto',
        'anioFundacion': 'Año de fundación',
        'empleadosCompleto': 'Empleados de tiempo completo',
        'empleadosParcial': 'Empleados de tiempo parcial',
        'totalColaboradores': 'Número total de colaboradores',
        'sector': 'Seleccione un sector',
        'subSector': 'Seleccione un sub-sector',
        'multinacional': 'Multinacional',
        'name_multinational_group':'Nombre del grupo multinacional',
        'region': 'Seleccione una región',
        'pais': 'País',
        'estado': 'Estado, ciudad o provincia',

        'nombreResponsable': 'Nombre',
        'apellidoResponsable': 'Apellido',
        'emailResponsable': 'Correo electrónico',
        'telResponsable': 'Teléfono',
        'extResponsable': 'Extensión',
        'celResponsable': 'Celular',

        'nombreRH': 'Nombre completo',
        'emailRH': 'Correo electrónico',
        'telRH': 'Teléfono',
        'extRH': 'Extensión',
        'celRH': 'Celular',

        'nombreTI': 'Nombre completo',
        'emailTI': 'Correo electrónico',
        'telTI': 'Teléfono',
        'extTI': 'Extensión',
        'celTI': 'Celular',

        'PDF_sector': 'Sector',
        'PDF_subSector': 'Sub-sector',
        'PDF_region': 'Región',
        'PDF_fecha': 'Fecha: ',
        'PDF_hora': 'Hora: ',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'Si',
          '2': 'No',
        },

      },
      'ERRORES': {
        'minlength': 'No ha introducido el número mìnimo de caracteres permitidos',
        'maxlength': 'Ha excedido el número máximo de caracteres permitidos',
        'max': 'El número introducido excede el máximo permitido',
        'min': 'El número introducido es menor al mínimo requerido',
        'pattern': 'El texto introducido contiene caracteres no permitidos en este campo',
        'email': 'El texto introducido no tiene el formato de correo electrónico correcto',
        'required': 'Este campo es obligatorio',
        'TEXT_ESPEC_ANIOFUNDA':'La fecha introducida excede la máxima permitida',
      }
    }
  }
};
